export default __webpack_public_path__ + "static/media/DPE_G_WHITE.066b17c0.png";